import React, {useCallback, useState} from "react";
import api from "../../api/organizations";

const initialData = {
  organizations: [],
  createdOrganization: null,
  deletedOrganization: null
};

export default function useOrganizations() {
  const [data, setOrganizationsData_] = React.useState(initialData);

  const [isCreatingOrganization, setIsCreatingOrganization] = useState(false);
  const [isDeletingOrganization, setIsDeletingOrganization] = useState(false);

  const setOrganizationsData = newData => {
    const newOrgData = {
      ...data,
      ...newData
    };

    setOrganizationsData_(newOrgData);
  };

  function getOrganizations() {
    api
      .getOrganizationsList()
      .then(({ data }) => setOrganizationsData({ organizations: data }));
  }

  const deleteOrganizations = useCallback((idList) => {
    setIsDeletingOrganization(true);
    return Promise.all(idList.map(api.deleteOrganization))
      .then(response => {
        setIsDeletingOrganization(false);
        setOrganizationsData({ deletedOrganization: response });
        //getOrganizations();
    }, () => {
        setIsDeletingOrganization(false);
      });
  }, [setIsDeletingOrganization])

  const createOrganization = useCallback((data) => {
    setIsCreatingOrganization(true);
    return api
      .createOrganization(data)
      .then(({ data }) => {
        setIsCreatingOrganization(false);
        setOrganizationsData({ createdOrganization: data });
        //getOrganizations();
      })
      .catch(() => {
        setIsCreatingOrganization(false);
      });
  }, [isCreatingOrganization])

  return {
    data,
    getOrganizations,
    deleteOrganizations,
    createOrganization,
    isCreatingOrganization,
    isDeletingOrganization
  };
}
